export default __webpack_public_path__ + "static/media/edit-icn.e6d3954b.svg";